import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { IEventoGenerico, IFilter, IPopulate, IQueryParam } from 'modelos/src';
import { HelperService } from '../../../../../../auxiliares/servicios/helper.service';
import { isModoDesactivadoActivo } from '../../../../../../auxiliares/modo-desactivado.util';
import { estadoHtml } from '../../../../../../auxiliares/tabla/celdas';
import { estadoTecnicoCelda } from '../../estado-tecnico.util';
import { retry, Subscription } from 'rxjs';
import {
  IRegExpSearch,
  IFiltroTabla,
} from '../../../../../../auxiliares/tabla/filtro/filtro.component';
import { IColumnas } from '../../../../../../auxiliares/tabla/tabla.component';
import { DialogService } from '../../../../../../auxiliares/dialog/dialog.service';
import { EventosGenericosHttpService } from '../../../../../../auxiliares/servicios/http/eventos-genericos.service';
import { AsignarGenericoComponent } from '../../asignar/asignar.component';
import { MatDialog } from '@angular/material/dialog';
import {
  CrearEditarEventoTecnicoGenericoComponent,
  ICrearEditarEventoTecnicoGenericoData,
} from '../../../../eventos-genericos/eventos-tecnicos-genericos/crear-editar/crear-editar-evento-tecnico-generico.component';
import { TratamientoGenericoComponent } from '../../../../eventos-genericos/tratar-evento-generico/tratamiento-generico/tratamiento-generico.component';
import { Lista2Service } from '../../../../../../auxiliares/servicios/lista2.service';
import { EventosGenericosHelperService } from '../../../../eventos-genericos/helper';
import { ClienteJerarquiaService } from '../../../../../../auxiliares/servicios/cliente-jerarquia.service';
import { escaparHtml } from '../../../../../../auxiliares/html-seguro.util';
import { FormularioDialogService } from '../../../../../../auxiliares/servicios/formulario-dialog.service';

@Component({
  selector: 'app-eventos-tecnicos-genericos',
  templateUrl: './eventos-tecnicos.component.html',
  styleUrl: './eventos-tecnicos.component.scss',
  standalone: false,
})
export class EventosTecnicosGenericosComponent implements OnInit, OnDestroy {
  helper = inject(HelperService);
  private clienteJerarquia = inject(ClienteJerarquiaService);
  private lista2 = inject(Lista2Service);
  private dialogService = inject(DialogService);
  private service = inject(EventosGenericosHttpService);
  private dialog = inject(MatDialog);
  private formularios = inject(FormularioDialogService);
  private eventosHelper = inject(EventosGenericosHelperService);

  @Input() id?: string;
  //// Tabla nueva
  public name = 'EventosTecnicosComponent';
  public datos: IEventoGenerico[] = [];
  public datos$?: Subscription;
  public totalCount = 0;
  public columnas?: IColumnas<IEventoGenerico>[];

  public search: IRegExpSearch = {
    fields: ['valores.titulo'],
  };
  // FILTROS de cliente. Propietario = coincidencia exacta; jerarquía = ese
  // cliente y toda su descendencia (idsAncestros no incluye al propio).
  public cliente: IFiltroTabla = {
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente',
    tipo: 'cliente-selector',
  };
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
  };
  public filtros: IFiltroTabla[] = [];

  public filter: IFilter<IEventoGenerico> = {
    estado: { $ne: 'Finalizado' },
    filtrador: 'Servicio Técnico',
  };
  public populate: IPopulate[] = [
    {
      path: 'cliente',
      select: 'nombre',
    },
    {
      path: 'activo',
      select: 'identificacion modoDesactivado categoria',
    },
    {
      path: 'luminaria',
      select: 'identificacion',
    },
    {
      path: 'sirena',
      // select: 'chipId',
    },
    {
      path: 'alarma',
      populate: [
        {
          path: 'domicilio',
          select: 'direccion identificacion geojson',
        },
        {
          path: 'comunicador',
          select: 'marca modelo',
        },
        {
          path: 'modelo',
          select: 'marca modelo',
        },
      ],
    },
    {
      path: 'tracker',
      select: 'identificacion',
    },
    {
      path: 'gateway',
      select: 'nombre',
    },
    {
      path: 'usuario',
      select: 'usuario datosPersonales',
    },
    // Ruta completa: detallesTecnicos es un subdocumento, no una referencia
    {
      path: 'detallesTecnicos.tecnico',
      select: 'usuario datosPersonales',
    },
  ];
  public query: IQueryParam = {
    populate: JSON.stringify(this.populate),
    filter: JSON.stringify(this.filter),
    sort: '-fechaCreacion',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    childrenLevel: 0,
  };

  public async listar(): Promise<void> {
    // El filtro fijo se suma al que arma la tabla (búsqueda y filtros del
    // usuario) en cada listar(); antes lo pisaba y los filtros no hacían nada.
    const filter: Record<string, unknown> = HelperService.stringToObject(
      this.query.filter,
    );
    Object.assign(filter, this.filter);
    if (this.id) {
      filter['idEntidad'] = this.id;
    }
    const query: IQueryParam = {
      ...this.query,
      filter: JSON.stringify(filter),
    };
    this.datos$?.unsubscribe();
    this.datos$ = this.lista2.eventosGenericos(query, 30).subscribe((data) => {
      this.totalCount = data.totalCount;
      this.datos = data.datos;
    });
  }

  // Acciones
  public async editar(dato: IEventoGenerico) {
    const data: ICrearEditarEventoTecnicoGenericoData = {
      id: dato._id,
    };
    const res = this.formularios.abrir(
      CrearEditarEventoTecnicoGenericoComponent,
      {
        tamano: 'grande',
        data,
      },
    );
    if (res) {
      res.afterClosed().subscribe((r) => {
        if (r) {
          this.listar();
        }
      });
    }
  }

  public async asignar(evento: IEventoGenerico) {
    const data = {
      id: evento._id,
      idTecnico: evento.detallesTecnicos?.idTecnicoAsignado,
    };

    const res = this.formularios.abrir(AsignarGenericoComponent, {
      tamano: 'mediano',
      data,
    });

    if (res) {
      res.afterClosed().subscribe((r) => {
        if (r) {
          this.listar();
        }
      });
    }
  }

  public async atender(data: IEventoGenerico) {
    this.dialog.open(TratamientoGenericoComponent, {
      data: { idEvento: data._id },
      hasBackdrop: false,
      minWidth: '1100px',
      maxWidth: '1500px',
    });
  }

  public async eliminar(dato: IEventoGenerico) {
    const res = await this.dialogService.confirm(
      'Eliminar servicio técnico',
      `¿Querés eliminar el evento?`,
    );
    if (!res) return;
    try {
      await this.service.delete(dato._id!);
      this.helper.notifSuccess('Evento eliminado');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  // Tabla

  private setColumnas() {
    const columnas: IColumnas<IEventoGenerico>[] = [
      // Fecha
      {
        header: {
          label: 'Fecha',
          sortable: true,
          sort: 'fechaCreacion',
        },
        row: {
          fecha: (dato) => dato.fechaCreacion,
          hace: true,
        },
      },
      // Estado
      {
        header: {
          label: 'Estado',
          sortable: true,
          sort: 'estado',
        },
        row: {
          estado: (dato) => estadoTecnicoCelda(dato),
          noData: 'Sin estado',
        },
      },
      // Título
      {
        header: {
          label: 'Título',
          sortable: true,
          sort: 'valores.titulo',
        },
        row: {
          parse(dato) {
            return dato.valores?.titulo;
          },
          noData: 'Sin título',
        },
      },
      // Categoría
      {
        header: {
          label: 'Categoría',
          sortable: true,
          sort: 'tipoEvento',
        },
        row: {
          parse(dato) {
            return dato.tipoEvento;
          },
          noData: 'Sin categoría',
        },
      },
      // Tracker o Alarma o Activo
      {
        header: {
          label: 'Entidad',
        },
        row: {
          html: (dato) => {
            const entidad = this.eventosHelper.obtenerEntidad(dato);
            const md = (dato.activo ?? dato.alarma)?.modoDesactivado;
            if (!entidad) return '';
            return isModoDesactivadoActivo(md)
              ? `<div class="tabla-celda-col">${entidad}<span>${estadoHtml({ texto: 'Desactivado', tono: 'neutro', icono: 'do_not_disturb_on' })}</span></div>`
              : entidad;
          },
          noData: 'Sin entidad',
        },
      },
      // Incidencia
      {
        header: {
          label: 'Código',
          sortable: true,
          sort: 'valores.numeroIncidente',
        },
        row: {
          parse: (dato) => {
            if (
              dato.tipoEvento === 'Evento Técnico Alarma' ||
              dato.tipoEvento === 'Evento Técnico Luminaria' ||
              dato.tipoEvento === 'Evento Técnico Sirena' ||
              dato.tipoEvento === 'Evento Técnico Tracker' ||
              dato.tipoEvento === 'Evento Técnico Gateway'
            ) {
              return dato.valores?.numeroIncidente
                ? dato.valores?.numeroIncidente.toUpperCase()
                : '';
            } else {
              return '';
            }
          },
          noData: 'Sin código',
        },
      },
      // Usuario
      // {
      //   header: {
      //     label: 'Usuario',
      //     sortable: true,
      //   },
      //   row: {
      //     parse(dato) {
      //       if (dato.usuario?.usuario || dato.usuario?.datosPersonales) {
      //         return (
      //           dato.usuario?.datosPersonales?.nombre || dato.usuario?.usuario
      //         );
      //       }
      //       return undefined;
      //     },
      //     noData: 'Sin Asignar',
      //   },
      // },

      // Tecnico
      {
        header: {
          label: 'Técnico',
        },
        row: {
          html(dato) {
            /// Foto - Nombre / Usuario
            const tecnico = dato.detallesTecnicos?.tecnico;
            if (tecnico) {
              const nombre = tecnico.datosPersonales?.nombre || tecnico.usuario;
              const fotoUrl =
                tecnico.datosPersonales?.foto || 'assets/images/anon.png';
              return `<div class="tabla-celda-fila">
                <img src="${escaparHtml(fotoUrl)}" alt="Foto" class="foto-vecino-avatar">
                ${nombre ? `<span>${escaparHtml(nombre)}</span>` : '<span class="no-info">Sin nombre</span>'}
              </div>`;
            }
            return '';
          },
          noData: 'Sin técnico asignado',
        },
      },
    ];

    // Cliente
    if (HelperService.getTipoCliente() !== 'Final') {
      {
        columnas.push({
          header: {
            label: 'Cliente',
          },
          row: {
            html: (dato) => this.clienteJerarquia.htmlNombre(dato.cliente),
            tooltip: (dato) =>
              this.clienteJerarquia.tooltipJerarquia(dato.cliente),
            noData: 'Sin cliente',
          },
        });
      }
    }

    // Acciones: pocas y sueltas (sin menú); Eliminar al final
    columnas.push({
      header: {
        label: 'Acciones',
      },
      row: {
        acciones: [
          {
            tipo: 'material',
            icon: 'edit',
            tooltip: 'Editar',
            click: (dato) => this.editar(dato),
            disabled: () =>
              !this.helper.tienePermiso(
                'Servicio Técnico - Editar solicitudes',
              ),
          },
          {
            tipo: 'material',
            icon: 'person_add',
            tooltip: 'Asignar técnico',
            click: (dato) => this.asignar(dato),
            disabled: () =>
              !this.helper.tienePermiso(
                'Servicio Técnico - Reasignar solicitudes',
              ),
          },
          {
            tipo: 'material',
            icon: 'troubleshoot',
            tooltip: 'Atender',
            click: (dato) => this.atender(dato),
            disabled: () =>
              !this.helper.tienePermiso(
                'Servicio Técnico - Atender solicitudes',
              ),
          },
          {
            tipo: 'material',
            color: 'warn',
            icon: 'delete',
            tooltip: 'Eliminar',
            click: (dato) => this.eliminar(dato),
            disabled: () =>
              !this.helper.tienePermiso(
                'Servicio Técnico - Eliminar solicitudes',
              ),
          },
        ],
      },
    });

    this.columnas = columnas;
  }

  // Hooks

  async ngOnInit() {
    if (HelperService.getTipoCliente() !== 'Final') {
      this.filtros.push(this.cliente);
      this.filtros.push(this.ancestro);
    }
    // Actualizar el query con el filtro
    this.setColumnas();
    await this.listar();
  }

  ngOnDestroy() {
    this.datos$?.unsubscribe();
  }
}
